const pick = require('lodash/pick');
const mapKeys = require('lodash/mapKeys');
const invert = require('lodash/invert');
const isEmpty = require('lodash/isEmpty');

export const keyConvert = (mappingKeys, requiredKeys, data, revertKey) => {
  if (revertKey) {
    mappingKeys = invert(mappingKeys);
  }
  let whitelistData = pick(data, Object.keys(mappingKeys));
  let dataConverted = mapKeys(whitelistData, function (value, key) {
    return mappingKeys[key];
  });
  for (const key of requiredKeys) {
    if (isEmpty(dataConverted[key])) {
      return null;
    }
  }
  return dataConverted;
};
